import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// FastAPI `detail` can be a string, a Pydantic 422 array or an object — always return a string for toasts/JSX
// (422 validation arrays are technical, so they fall back to the friendly message).
export function apiErrorMessage(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (d && typeof d.message === "string") return d.message;
  return fallback;
}
